import { useEnvironmentInterface } from "environment-interface";

import { useAnalytics } from "hooks/useAnalytics";

import type { Command } from "../types";

export const useToggleCommandPaletteCommand = (
  event_source: "main_menu" | "keyboard" | "onboarding",
): Command => {
  const { monacoEditor } = useEnvironmentInterface();
  const track = useAnalytics();

  return {
    id: "codesandbox.layout.commandPalette",
    name: "Command Palette",
    section: "Layout",
    // Cmd+K is inferred and handled by kbar
    binding: "$mod+Shift+P",
    perform: async () => {
      track("open_command_palette", { event_source });
      const vscodeApi = await monacoEditor.getExtensionApi();
      vscodeApi.commands.executeCommand("workbench.action.showCommands");
    },
  };
};
